import React from "react"
import Container from "@ecom/ui/components/Container"
import { CupcakeImg, CardImg, CardsSvg, HeadphonesImg, ShopSvg, WalletSvg } from "./img"

import * as styles from "./betterHalva.module.scss"

type Props = {
  orderNum?: string
  title?: string
}

const defaultTitle = "Почему карта рассрочки* выгоднее получения займа в МФО?"

export const BetterHalva = ({ orderNum, title = defaultTitle }: Props) => (
  <section className={styles.section} data-exclude={orderNum}>
    <Container>
      <h2 className={styles.head}>{title}</h2>
      <div className={styles.grid}>
        <div className={styles.block1}>
          <h3 className={styles.title}>Кэшбэк до 10% с подпиской «Халва.Десятка»</h3>
          <ShopSvg className={styles.icon} />
          <HeadphonesImg alt="headphones" className={styles.img} objectPosition="top left" />
        </div>
        <div className={styles.block2}>
          <h3 className={styles.title}>Лимит до 500 000 рублей на покупки до 10 месяцев</h3>
          <WalletSvg className={styles.icon} />
          <CardImg alt="halva" className={styles.img} objectPosition="top left" />
        </div>
        <div className={styles.block3}>
          <h3 className={styles.title}>
            Снятие наличных в&nbsp;рассрочку* <br /> на 3 месяца
          </h3>
          <CardsSvg className={styles.icon} />
          <CupcakeImg alt="cake" className={styles.img} objectPosition="top left" />
        </div>
      </div>
    </Container>
  </section>
)
